import { ISpace, ISpaceOnMap } from "../interfaces/spaces";
import { Point } from "../models/point";

export class ModelUtils {
	public static async getAllSpacesFromViewModelAsync(
		model: Autodesk.Viewing.Model,
		spaces: Record<string, ISpace>,
		propertiesToInclude: string[] = []
	): Promise<ISpaceOnMap[]> {
		const assetIdProperty = "BE:AssetID";
		const spaceIds = Object.keys(spaces);
		const ignoreSpaceFilter = spaceIds.length === 0;

		return new Promise<ISpaceOnMap[]>((resolve) => {
			model.getBulkProperties2([], {}, (propResults) => {
				const result: ISpaceOnMap[] = propResults
					.filter((item) => item.properties.length > 0 && item.properties.some(property => property.displayName === assetIdProperty))
					.map((item) => (
						{
							dbId: item.dbId,
							id: item.properties.find((p) => p.displayName === assetIdProperty)!.displayValue,
							properties: propertiesToInclude.length > 0 ?
								Object.assign({}, ...item.properties
									.filter((p) => propertiesToInclude.indexOf(p.displayName) >= 0)
									.map(property => ({ [property.displayName]: property.displayValue })))
								: {},
						}
					))
					.filter((item) => ignoreSpaceFilter || spaceIds.indexOf(item.id.toString()) >= 0)
					.map((item) => {
						const spaceBound = ModelUtils.getBounds(model, item.dbId);
						return {
							dbId: item.dbId,
							id: item.id,
							properties: item.properties,
							position: Point.FromVector(spaceBound.getCenter()),
							beSpace: !ignoreSpaceFilter ? spaces[item.id] : undefined,
						};
					});

				return resolve(result);
			});
		});
	}

	public static getBounds(model: Autodesk.Viewing.Model, dbId: number): THREE.Box3 {
		const bounds = new THREE.Box3();
		if (!model) {
			return bounds;
		}

		const modelData = model.getData();
		if (!modelData) {
			return bounds;
		}

		const bc = new Autodesk.Viewing.Private.BoundsCallback(bounds);

		const fragIds = modelData.fragments.dbId2fragId[dbId];
		// fragId is either a single vertex buffer or an array of vertex buffers
		if (Array.isArray(fragIds)) {
			for (var j = 0; j < fragIds.length; j++) {
				// go through each vertex buffer, looking for the object id
				ModelUtils.find2DBounds(model, fragIds[j], dbId, bc);
			}
		} else if (typeof fragIds === 'number') {
			// go through the specific vertex buffer, looking for the object id
			ModelUtils.find2DBounds(model, fragIds, dbId, bc);
		}

		return bounds;
	}

	private static find2DBounds(model: Autodesk.Viewing.Model, fragId: number, dbId: number, bc: Autodesk.Viewing.Private.BoundsCallback): void {
		var mesh = model.getFragmentList().getVizmesh(fragId);
		if (!mesh) {
			return;
		}
		var vbr = new Autodesk.Viewing.Private.VertexBufferReader(mesh.geometry);
		vbr.enumGeomsForObject(dbId, bc);
	}
}
